"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qnToLastCalledAdapter = void 0;
const lastCalledDescriptionAdapter_1 = require("./lastCalledDescriptionAdapter");
const qnToLastCalledAdapter = (qn) => {
    return {
        title: qn.number,
        description: (0, lastCalledDescriptionAdapter_1.lastCalledDescriptionAdapter)(qn),
    };
};
exports.qnToLastCalledAdapter = qnToLastCalledAdapter;
//# sourceMappingURL=qnToLastCalledAdapter.js.map